const Validation = {
    tag: (value) => {
      if (!value) return "Tag is required.";
      if (value.length > 16 || value.length < 4) return "Tag length must be between 4 and 16 characters.";
      if (!/^[a-zA-Z0-9_-]+$/.test(value)) return "Tag must only contain letters, numbers, dashes, or underscores.";
      return null; // No error
    },
};

export default Validation;